import noop from '@gaia/util/noop/action'

export default {
  contacts: noop,
}
